import { Component, OnInit, OnDestroy } from '@angular/core';

import moment from 'moment-timezone';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { mergeMap, filter, distinctUntilChanged } from 'rxjs/operators';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { UserStateModel } from '../../../Core/Users/models/user-state.model';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';
import { LoginApi } from '../../../api/login/login.api';
import { messageSeverityEnum } from '../../../Common/Misc/enums/message-severity.enum';

interface SSO {
    label: string;
    date: Date;
}

@Component({
    selector: 'agpr-sso-management',
    templateUrl: './sso-management.component.html',
    styleUrls: ['sso-management.component.scss'],
    standalone: false
})
export class SsoManagementComponent implements OnInit, OnDestroy {

    auths: SSO[] = [];

    whiteLabel: string = '';
    expirationDate: Date = moment().add(60, 'days').toDate();
    confirmation: boolean = false;

    private userState: UserStateModel;
    private partnerId: number = null;
    private subscriptions: Subscription[] = [];

    readonly id = 'ssoManagement';
    readonly buttonTypes = ButtonTypesEnum;
    readonly minDate: Date = moment().add(1, 'days').toDate();

    constructor(
        private userStateService: CurrentUserStateService,
        private loginApi: LoginApi,
        private messageService: MessageService,
    ) {}


    ngOnInit() {
        this.subscriptions.push(
            this.userStateService.getState().pipe(
                filter(x => !!x),
                distinctUntilChanged(),
                mergeMap((userState) => {
                    this.userState = userState;
                    this.partnerId = this.userState.account.partnerResellerId;
                    this.whiteLabel = this.userState.account.partnerResellerName;
                    this.expirationDate = this.userState.account.expiryDate.toDate();

                    return this.loginApi.getSSO(this.partnerId);
                })
            ).subscribe({
                next: (sso: any) => {
                    this.auths.push({ label: this.whiteLabel, date: sso.expirationDate });
                },
                error: () => {
                    // returns 404 when no auths exist
                }
            })
        );
    }

    authorize() {
        this.confirmation = false;
        this.loginApi.generateSSO(this.partnerId, this.expirationDate.getTime()).subscribe({
            next: () => {
                this.auths.push({label: this.whiteLabel, date: this.expirationDate });
                this.messageService.add({
                    severity: messageSeverityEnum.success,
                    detail: 'Sso.Management.success.authorize'
                });
            },
            error: () => {
                this.messageService.add({
                    severity: messageSeverityEnum.error,
                    detail: 'Sso.Management.error.authorize'
                });
            }
        });
    }

    deleteAuth(auth: SSO) {
        this.loginApi.deleteSSO(this.partnerId).subscribe({
            next: () => {
                const index = this.auths.findIndex(x => x === auth);
                if (index > -1) {
                    this.auths.splice(index);
                }
                this.messageService.add({
                    severity: messageSeverityEnum.success,
                    detail: 'Sso.Management.success.deleteSSO'
                });
            },
            error: () => {
                this.messageService.add({
                    severity: messageSeverityEnum.error,
                    detail: 'Sso.Management.error.deleteSSO'
                });
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
